import { useState, useEffect } from "react"
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom"
import { BarChart3, FileText, CheckCircle, Send, BookOpen, Settings, LogOut, Menu } from "lucide-react"

export default function DashboardLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [userEmail, setUserEmail] = useState("")

  useEffect(() => {
    if (typeof window === 'undefined') return
    
    const isAuthenticated = localStorage.getItem("isAuthenticated")
    const email = localStorage.getItem("userEmail")

    if (!isAuthenticated) {
      navigate("/login")
    } else {
      setUserEmail(email || "")
    }
  }, [navigate])

  const handleLogout = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem("isAuthenticated")
      localStorage.removeItem("userEmail")
    }
    navigate("/login")
  }

  const menuItems = [
    { href: "/dashboard", label: "Dashboard", icon: BarChart3 },
    { href: "/dashboard/daily-reports", label: "Daily Reports", icon: FileText },
    { href: "/dashboard/verification", label: "Verification", icon: CheckCircle },
    { href: "/dashboard/broadcast", label: "Broadcast Reports", icon: Send },
    { href: "/dashboard/dictionary", label: "Dictionary", icon: BookOpen },
    { href: "/dashboard/settings", label: "Settings", icon: Settings },
  ]

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <aside
        className={`${sidebarOpen ? "w-64" : "w-20"} bg-sidebar text-sidebar-foreground transition-all duration-300 flex flex-col border-r border-sidebar-border`}
      >
        <div className="p-4 border-b border-sidebar-border flex items-center justify-between">
          <h1 className={`font-bold text-lg text-sidebar-primary ${!sidebarOpen && "hidden"}`}>AgenVX</h1>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 hover:bg-sidebar-accent/10 rounded-lg transition-colors"
          >
            <Menu size={20} />
          </button>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.href
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`flex items-center gap-3 px-4 py-2 rounded-lg transition-colors ${
                  isActive
                    ? "bg-sidebar-primary text-sidebar-primary-foreground"
                    : "text-sidebar-foreground hover:bg-sidebar-accent/10"
                }`}
              >
                <Icon size={20} />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            )
          })}
        </nav>

        {/* User Info & Logout */}
        <div className="p-4 border-t border-sidebar-border space-y-3">
          {sidebarOpen && (
            <div className="px-2 py-2 bg-sidebar-accent/10 rounded-lg">
              <p className="text-xs text-sidebar-foreground/70">Logged in as</p>
              <p className="text-sm font-medium text-sidebar-foreground truncate">{userEmail}</p>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-4 py-2 text-sm bg-destructive/10 hover:bg-destructive/20 rounded-lg transition-colors"
            style={{ color: '#ef4444' }}
          >
            <LogOut size={16} />
            {sidebarOpen && <span style={{ color: '#ef4444', fontWeight: 600 }}>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

